export const NotFound = () => {
  window.location.href = "/";
  return null;
};
